/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { xBaseTheme } from "@monsma/XDL/types";

export default {
    primary: {
        main: "#128C98",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#0B2E49",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#E7E7E7",
        disabled: "#CCCCCC",
        black: "#000000",
        ui1: "#0B2E49",
        ui2: "#1D3E91",
        ui3: "#488FEB",
        ui4: "#121658",
        ui5: "#A1CAFF",
        ui6: "#242A31",
        ui7: "#FAFAFA",
        ui8: "#DEDEDE",
        ui9: "#888888",
        ui10: "#333333",
        ui11: "#FAF9F8",
        ui12: "#DBD8CC",
        ui13: "#89867B",
        ui14: "#BCC22F",
        ui15: "#C4E2E5",
        ui16: "#FFA9A9",
        ui17: "#E98A8A",
        ui18: "#F4F4F4",
        ui19: "#BDBDBD",
        ui20: "#b8b7b7",
        ui21: "#F3F3F3",
        ui22: "#0C1827",
        ui23: "#0A2A36",
        ui24: "#DBDBCC",
        ui25: "#E5615B",
        ui26: "#999999",
    },
    text: {
        main: "#434348",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#2E64B0",
        inverse: "#FFFFFF",
    },
    success: {
        main: "#15CA48",
        contrast: "#E7F9EC",
    },
    danger: {
        main: "#D01C1C",
        contrast: "#FAE8E8",
    },
    warning: {
        main: "#E3BB26",
        contrast: "#FCF8E9",
    },
    info: {
        main: "#088DA2",
        contrast: "#E6F3F5",
    },
} as xBaseTheme["colors"];
